// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-scrollbar::-webkit-scrollbar {
  width: 5px;
  height: 5px; }

.chat-scrollbar::-webkit-scrollbar-thumb {
  background: #4d2481;
  border-radius: 5px; }

.chat-scrollbar::-webkit-scrollbar-track-piece {
  background: #e7e0f0;
  border-radius: 5px;
  margin-block: 15px; }

.chat-scrollbar {
  scrollbar-face-color: #4d2481;
  scrollbar-track-color: #e7e0f0; }
`, "",{"version":3,"sources":["webpack://./src/page-components/cabinet/chat/[id]/ChatWindow/scrollbar.scss"],"names":[],"mappings":"AAQE;EACE,UAsBgB;EArBhB,WAqBgB,EAAA;;AAlBlB;EACE,mBAkBiB;EAjBjB,kBAmBc,EAAA;;AAhBhB;EACE,mBAckB;EAblB,kBAec;EAdd,kBAAkB,EAAA;;AAIpB;EACE,6BAMiB;EALjB,8BAMkB,EAAA","sourcesContent":["@mixin scrollbars(\r\n  $size,\r\n  $foreground-color,\r\n  $background-color,\r\n  $thumb-radius,\r\n  $track-radius\r\n) {\r\n  // for Google Chrome\r\n  &::-webkit-scrollbar {\r\n    width: $size;\r\n    height: $size;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background: $foreground-color;\r\n    border-radius: $thumb-radius;\r\n  }\r\n\r\n  &::-webkit-scrollbar-track-piece {\r\n    background: $background-color;\r\n    border-radius: $track-radius;\r\n    margin-block: 15px;\r\n  }\r\n\r\n  // for Internet Explorer\r\n  & {\r\n    scrollbar-face-color: $foreground-color;\r\n    scrollbar-track-color: $background-color;\r\n  }\r\n}\r\n\r\n$scrollbar-size: 5px;\r\n$purple-base: #4d2481;\r\n$purple-light: #e7e0f0;\r\n$thumb-radius: 5px;\r\n$track-radius: 5px;\r\n\r\n.chat-scrollbar {\r\n  @include scrollbars(\r\n    $scrollbar-size,\r\n    $purple-base,\r\n    $purple-light,\r\n    $thumb-radius,\r\n    $track-radius\r\n  );\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
